var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.content.mobile, function (category) {
      return _c("li", { staticClass: "mainItem" }, [
        _c(
          "a",
          {
            staticClass: "has-sub",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                return _vm.categoryClick($event, category)
              },
            },
          },
          [_vm._v(_vm._s(category.name))]
        ),
        _vm._v(" "),
        _vm.isDisplayFor("mobile")
          ? _c("div", { staticClass: "level02" }, [
              _c(
                "ul",
                _vm._l(category.items, function (subcat) {
                  return _c("li", [
                    _c(
                      "a",
                      {
                        class: { "has-sub": subcat["sub-sub-items"].length },
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.categoryClick($event, subcat)
                          },
                        },
                      },
                      [_vm._v(_vm._s(subcat["sub-item"].name))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "level03" }, [
                      _c(
                        "ul",
                        _vm._l(subcat["sub-sub-items"], function (subSubcat) {
                          return _c("li", [
                            _c(
                              "a",
                              {
                                attrs: { href: subSubcat.url },
                                on: {
                                  click: function ($event) {
                                    return _vm.subcatClick($event, subSubcat)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(subSubcat.name))]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isDisplayFor("desktop")
          ? _c("div", { staticClass: "level02 newColumns" }, [
              _c("div", { staticClass: "bottomBar menuHeaderBar" }, [
                _c(
                  "button",
                  [
                    _c(
                      "a",
                      {
                        staticClass: "menuHeaderText",
                        attrs: { href: category.url },
                      },
                      [_vm._v(_vm._s(category.name) + " HOME")]
                    ),
                    _vm._v(" "),
                    _c("svg-icon", {
                      attrs: { "icon-name": "icon-chevron-down" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "level01" }, [
                  _c(
                    "ul",
                    _vm._l(category.items, function (subCat) {
                      return _c("li", [
                        subCat["sub-sub-items"].length
                          ? _c(
                              "a",
                              {
                                staticClass: "has-sub",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.categoryClick($event, subCat)
                                  },
                                },
                              },
                              [
                                subCat["sub-item"]["is-bold"]
                                  ? _c("strong", [
                                      _vm._v(_vm._s(subCat["sub-item"].name)),
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(subCat["sub-item"].name)),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !subCat["sub-sub-items"].length
                          ? _c(
                              "a",
                              {
                                attrs: { href: subCat["sub-item"].url },
                                on: {
                                  click: function ($event) {
                                    return _vm.categoryClick($event, subCat)
                                  },
                                },
                              },
                              [
                                subCat["sub-item"]["is-bold"]
                                  ? _c("strong", [
                                      _vm._v(_vm._s(subCat["sub-item"].name)),
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(subCat["sub-item"].name)),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        subCat["sub-sub-items"].length
                          ? _c("div", { staticClass: "level02 newColumns" }, [
                              _c(
                                "div",
                                { staticClass: "bottomBar menuHeaderBar" },
                                [
                                  _c(
                                    "button",
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "menuHeaderText",
                                          attrs: {
                                            href: subCat["sub-item"].url,
                                          },
                                        },
                                        [
                                          subCat["sub-item"]["is-bold"]
                                            ? _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    subCat["sub-item"].name
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    subCat["sub-item"].name
                                                  )
                                                ),
                                              ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("svg-icon", {
                                        attrs: {
                                          "icon-name": "icon-chevron-down",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "level01" }, [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        subCat["sub-sub-items"],
                                        function (subSubCat) {
                                          return _c("li", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "menuLastLevel",
                                                attrs: { href: subSubCat.url },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.subcatClick(
                                                      $event,
                                                      subSubCat
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                subSubCat["is-bold"]
                                                  ? _c("strong", [
                                                      _vm._v(
                                                        _vm._s(subSubCat.name)
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(subSubCat.name)
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }